import { trackingConfig } from './constants';
import { getApplicationInfo } from './trackingConfig';

export const IS_SSR: boolean = typeof window === 'undefined';
export const IS_VIMEO_COM = IS_SSR || location.host.endsWith('vimeo.com');

export function trackError(error: Error, errorContext: Record<string, unknown>): void {
  if (trackingConfig.LOG_ERRORS_TRACKED <= trackingConfig.LOG_ERRORS_LIMIT) {
    trackingConfig.LOG_ERRORS_TRACKED += 1;
  } else {
    return console.debug('Skipping error tracking, session facing limit');
  }

  const errorInfo = {
    ...errorContext,
    ...getApplicationInfo(),
  };

  if (IS_VIMEO_COM && window.DD_RUM) {
    window.DD_RUM.onReady(() => {
      const globals = window.DD_RUM.getUser() ?? null;
      console.debug('Sending Datadog report', { error, errorInfo, globals });
      window.DD_RUM.addError(error, errorInfo);
    });
  }
}

export function trackAction(
  action: string,
  actionContext: Record<string, string | number | boolean> = {},
): void {
  try {
    const actionInfo = Object.assign({}, actionContext, getApplicationInfo());

    if (IS_VIMEO_COM && window.DD_RUM) {
      window.DD_RUM.onReady(() => {
        const globals: Record<string, unknown> | null = window.DD_RUM.getUser() ?? null;
        console.debug('Sending Datadog action', { action, actionInfo, globals });
        window.DD_RUM.addAction(action, actionInfo);
      });
    } else {
      console.debug('Got local Datadog action', { action, actionInfo, globals: null });
    }
  } catch {}
}
